<template>
    <div>
        <div class="row q-col-gutter-sm">
            <q-radio v-for="(service, index) in paymentServices"
                     dense
                     class="col-12"
                     :key="index"
                     v-model="paymentMethod"
                     :val="service.value"
                     :label="service.label" />
        </div>

        <q-btn v-if="paymentMethod !== 'invoice'"
               type="submit"
               class="bg-primary text-white q-mt-md"
               label="Оплатить" @click.prevent="pay" />

        <q-btn v-else
               class="bg-primary text-white q-mt-md"
               label="Сформировать счёт"
               @click.prevent="invoice"/>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "PaymentServices",
        props: {
            order: {
                required: true,
                type: Object
            },
        },
        data () {
            return {
                paymentMethod: ''
            }
        },
        computed: {
            ...mapState('customer', [
                'paymentServices',
            ]),
        },
        methods: {
            invoice () {
                window.location.href = '/account/orders/' + this.order.id + '/invoice';
            },

            pay () {
                axios.post(`/account/payments/${this.order.id}/make`, {
                    method: this.paymentMethod,
                })
                    .then(response => {
                        if (response.data.status === 'success' && response.data.redirect) {
                           window.location.href = response.data.redirect;
                        }
                    });
            },
        }
    }
</script>
